// export const BaseAPIURL = 'https://tour-app-api.glitch.me/api/'
// export const IMG_URL = 'https://tour-app-api.glitch.me/uploads/'

export const BaseAPIURL =
  "https://tourproxyapi.westafricantoursinfo.com/api/watl/";

export const transportBase =
  "https://tourproxyapi.westafricantoursinfo.com/api/transport/";
export const IMG_URL = "https://tourproxyapi.westafricantoursinfo.com/images/";
